<div class="wrap-loader" *ngIf="show">
  <div class="loader">
    <vcl-loading-circle
      class="loading-circle"
      [hideLoading]="false"
      loadingTitle="exemploTitle"
      size="large"
      inverse="true"
    >
    </vcl-loading-circle>
    <div class="timer">{{ percentValue }}%</div>
    <div class="message">{{ msg }}</div>
  </div>
</div>
